function camelToWords(key) {
  const result = key.replace(/([A-Z])/g, ' $1');

  return result.split(' ').join(' ').toLowerCase();
}

export default camelToWords;
